import { Grid, Input, Popover, Popup, Tag, Toast } from 'antd-mobile'
import React, { useState } from 'react'
import Icon from '../../icon'
import { useNavigate } from 'react-router-dom'
import { DownOutline } from 'antd-mobile-icons'
import { LEAVE_REASONS } from '../../features/match/model/leaveReasons'
import './signupEditSheet.css'

const SIGNUP_ACTIONS = [
    { value: 0, label: '球员', icon: '🏃' },
    { value: 1, label: '主裁', icon: '🏁' },
    { value: 2, label: '边裁', icon: '🚩' },
    { value: 3, label: 'VAR', icon: '🖥️' },
    { value: 4, label: '观众', icon: '🍿' },
    { value: 5, label: '请假', icon: '🏖️' },
];

const OthersTeam = ({ gameDetail, memberInfo, currentUser, handleSignUp }) => {
    const navigate = useNavigate()
    const [editingUser, setEditingUser] = useState(null);
    const [editStage, setEditStage] = useState('identity');
    const [leaveReason, setLeaveReason] = useState('');
    const [leaveDetail, setLeaveDetail] = useState('');

    // 懒人、待定与请假成员统一从头像进入同一个底部编辑面板。
    const openMemberEditor = user => {
        const canEdit = currentUser?.admin === 1
            || memberInfo?.some(referee => referee.id === currentUser?.id && [1, 2].includes(referee.gameType));
        if (!canEdit) {
            navigate(`/members/${user.id}`);
            return;
        }
        const currentReason = LEAVE_REASONS.find(item => user.remark?.startsWith(item.value));
        setLeaveReason(currentReason?.value || '');
        setLeaveDetail(currentReason ? user.remark.slice(currentReason.value.length).replace(/^：/, '') : (user.remark || ''));
        setEditStage('identity');
        setEditingUser(user);
    };

    const closeEditor = () => setEditingUser(null);

    const selectIdentity = value => {
        if (value === 5) {
            setEditStage('leave');
            return;
        }
        const memberId = editingUser.id;
        closeEditor();
        handleSignUp(value, null, memberId);
    };

    const saveLeave = () => {
        // 与队员自行请假保持相同的“快捷原因：补充说明”保存格式。
        const reason = [leaveReason, leaveDetail.trim()].filter(Boolean).join('：');
        if (!reason) {
            Toast.show({ icon: 'fail', content: '请选择或输入请假原因' });
            return;
        }
        const memberId = editingUser.id;
        closeEditor();
        handleSignUp(5, reason, memberId);
    };
    const mainImage = (member) => {
        const image = member?.memberImageList
            ?.find(item => item.type === 0)
            ?.image
        if (image) {
            return image + Icon.ImageFooter;
        } else {
            return Icon.KEPENG_LOGO;
        }
    }

    const replaceRemark = (remark) => {
        if (!remark) return null;
        if (remark.startsWith('工作原因')) {
            return (
                <div className="remark-tag-wrapper">
                    <Tag color='warning' fill='outline'>工作</Tag>
                    <span className="remark-text">{remark.replace("工作原因", "")}</span>
                </div>
            )
        } else if (remark.startsWith('家庭原因')) {
            return (
                <div className="remark-tag-wrapper">
                    <Tag color='success' fill='outline'>家庭</Tag>
                    <span className="remark-text">{remark.replace("家庭原因", "")}</span>
                </div>
            )
        } else if (remark.startsWith('身体原因')) {
            return (
                <div className="remark-tag-wrapper">
                    <Tag color='danger' fill='outline'>身体</Tag>
                    <span className="remark-text">{remark.replace("身体原因", "")}</span>
                </div>
            )
        } else if (remark.startsWith('饭局')) {
            return (
                <div className="remark-tag-wrapper">
                    <Tag color='primary' fill='outline'>饭局</Tag>
                    <span className="remark-text">{remark.replace("饭局", "")}</span>
                </div>
            )
        } else {
            return (
                <div className="remark-tag-wrapper">
                    <Tag color='default' fill='outline'>其他</Tag>
                    <span className="remark-text">{remark.replace("其他", "")}</span>
                </div>
            )
        }
    }

    // Sub-component for categorized leave reasons with grid/list toggle
    const LeaveCategory = ({ reason, groupMembers, gIndex }) => {
        const [isExpanded, setIsExpanded] = useState(false);
        return (
            <div key={reason} className={`leave-reason-group ${gIndex === 0 ? 'first' : ''}`}>
                <div
                    className="leave-reason-header"
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    <div className="leave-reason-left">
                        <span className="leave-reason-text">{reason} &nbsp;{groupMembers.length}</span>
                    </div>
                    <div className={`leave-category-chevron ${isExpanded ? 'rotated' : ''}`}>
                        <DownOutline fontSize={14} />
                    </div>
                </div>

                <div className="leave-category-content">
                    {isExpanded ? (
                        <div className="leave-items-list-detailed">
                            {groupMembers.map((user, index) => (
                                <div key={user.id || index} className="leave-item-row-detailed" onClick={() => {
                                    openMemberEditor(user);
                                }}>
                                    <div className="leave-item-avatar-wrapper">
                                        <img src={mainImage(user)} className="leave-item-avatar-small" alt={user.name} />
                                    </div>
                                    <div className="leave-item-content">
                                        <div className="leave-item-name-row">
                                            <span className="leave-item-name-bold">{user.name}</span>
                                            <span className="leave-item-tag">详情</span>
                                        </div>
                                        <div className="leave-item-remark-text">{user.remark || '未填写具体原因'}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="leave-items-grid-compact">
                            <Grid columns={4} gap={10}>
                                {groupMembers.map((user, index) => (
                                    <Grid.Item key={user.id || index}>
                                        <div className="leave-grid-item-compact" onClick={() => {
                                            openMemberEditor(user);
                                        }}>
                                            <img src={mainImage(user)} className="leave-grid-avatar-compact" alt={user.name} />
                                            <div className="leave-grid-name-compact">{user.name}</div>
                                        </div>
                                    </Grid.Item>
                                ))}
                            </Grid>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const renderMemberGridItem = (user, showRemark = false) => {
        return (
            <div className="mini-player-item" onClick={() => openMemberEditor(user)}>
                <div className="mini-avatar-wrapper">
                    {user.remark ? (
                        <Popover
                            content={<div className="glass-popover-content">{user.name}: {replaceRemark(user.remark)}</div>}
                            trigger='click'
                            placement='bottom'
                            mode='dark'
                        >
                            <img src={mainImage(user)} className="mini-avatar" alt={user.name} />
                        </Popover>
                    ) : (
                        <img src={mainImage(user)} className="mini-avatar" alt={user.name} />
                    )}
                </div>
                <div className="mini-player-name">{user.name}</div>
                {showRemark && user.remark && (
                    <div className="mini-remark-inline">
                        {replaceRemark(user.remark)}
                    </div>
                )}
            </div>
        )
    }

    const leaveList = memberInfo?.filter(item => item.gameType === 5) || []

    const renderLeaveSection = (title, members) => {
        if (!members || members.length === 0) return null;

        const keywords = ['工作', '家庭', '身体', '饭局', '出差', '其他'];
        const groups = {
            '工作': [], '家庭': [], '身体': [], '饭局': [], '出差': [], '其他': []
        };

        members.forEach(user => {
            const remark = user.remark || '';
            const match = keywords.find(k => remark.startsWith(k));
            if (match) {
                groups[match].push(user);
            } else {
                groups['其他'].push(user);
            }
        });

        return (
            <div className="member-category-card">
                <div className="member-category-header">
                    <div className="member-category-title">
                        {title} ({members.length})
                    </div>
                </div>
                <div className={`member-category-content`}>
                    <div className="leave-content-wrapper">
                        {Object.entries(groups).map(([reason, groupMembers], gIndex) => {
                            if (groupMembers.length === 0) return null;
                            return (
                                <LeaveCategory
                                    key={reason}
                                    reason={reason}
                                    groupMembers={groupMembers}
                                    gIndex={gIndex}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    const tempMemberList = memberInfo.filter(item => item.gameType === 6)
        .sort((a, b) => (a?.name || '').localeCompare(b?.name || ''));

    const lazyMemberList = memberInfo?.filter(item => !item.tempMember && item.gameType === null)
        .sort((a, b) => (a?.name || '').localeCompare(b?.name || ''));

    return (
        <div className="others-team-container">
            {renderLeaveSection('请假人员', leaveList)}

            {tempMemberList.length > 0 && (
                <div className="member-category-card">
                    <div className="member-header-container">
                        <div className="member-category-title">
                            待定人员 ({tempMemberList.length})
                        </div>
                    </div>
                    <div className="member-category-content">
                        {/* H5 展示改为四列，给姓名留出空间，点击逻辑保持不变。 */}
                        <Grid columns={4} gap={12}>
                            {tempMemberList.map(user => (
                                <Grid.Item key={user.id}>
                                    {renderMemberGridItem(user)}
                                </Grid.Item>
                            ))}
                        </Grid>
                    </div>
                </div>
            )}

            {lazyMemberList.length > 0 && (
                <div className="member-category-card">
                    <div className="member-header-container">
                        <div className="member-category-title">
                            懒人 ({lazyMemberList.length})
                        </div>
                    </div>
                    <div className="member-category-content">
                        {/* H5 展示改为四列，避免球员姓名被过度截断。 */}
                        <Grid columns={4} gap={12}>
                            {lazyMemberList.map(user => (
                                <Grid.Item key={user.id}>
                                    {renderMemberGridItem(user)}
                                </Grid.Item>
                            ))}
                        </Grid>
                    </div>
                </div>
            )}
            <Popup
                visible={!!editingUser}
                onMaskClick={closeEditor}
                bodyStyle={{ borderTopLeftRadius: 22, borderTopRightRadius: 22, overflow: 'hidden' }}
                style={{ '--z-index': 1250 }}
            >
                <div className="signup-edit-sheet">
                    <div className="signup-edit-header">
                        <button type="button" onClick={() => editStage === 'leave' ? setEditStage('identity') : closeEditor()}>
                            {editStage === 'leave' ? '返回' : '取消'}
                        </button>
                        <div className="signup-edit-header-copy">
                            <strong>{editStage === 'leave' ? '请假报备' : '修改报名信息'}</strong>
                            <span>{editStage === 'leave' ? '选择原因，也可补充具体说明' : '点击身份即可保存本场报名状态'}</span>
                        </div>
                        <span className="signup-edit-header-spacer" />
                    </div>
                    <div className="signup-edit-content">
                        {editingUser && <div className="signup-edit-person">
                            <img src={mainImage(editingUser)} alt={editingUser.name} />
                            <div><strong>{editingUser.name}</strong><span>当前：{SIGNUP_ACTIONS.find(item => item.value === editingUser.gameType)?.label || '未报名'}</span></div>
                        </div>}
                        {editStage === 'identity' ? <>
                            <div className="signup-edit-section-title">选择新的报名身份</div>
                            <div className="signup-edit-options">
                                {SIGNUP_ACTIONS.map(item => <button
                                    key={item.value}
                                    type="button"
                                    className={`signup-edit-option ${editingUser?.gameType === item.value ? 'active' : ''}`}
                                    onClick={() => selectIdentity(item.value)}
                                ><span>{item.icon}</span><span>{item.label}</span></button>)}
                            </div>
                        </> : <>
                            <div className="signup-edit-section-title">快速选择原因</div>
                            <div className="signup-edit-reason-grid">
                                {LEAVE_REASONS.map(item => <button
                                    key={item.value}
                                    type="button"
                                    className={`signup-edit-option ${leaveReason === item.value ? 'active' : ''}`}
                                    aria-pressed={leaveReason === item.value}
                                    onClick={() => setLeaveReason(item.value)}
                                >{item.label}</button>)}
                            </div>
                            <div className="signup-edit-section-title">补充说明</div>
                            <Input className="signup-edit-input" placeholder="填写具体原因（选填）" value={leaveDetail} onChange={setLeaveDetail} />
                        </>}
                    </div>
                    <div className="signup-edit-footer">
                        <button type="button" onClick={closeEditor}>取消</button>
                        {editStage === 'leave' && <button type="button" className="primary" onClick={saveLeave}>保存请假</button>}
                    </div>
                </div>
            </Popup>
        </div>
    )
}


export default OthersTeam;
